import Auth from "./Auth";
import Clinics from "./Clinics";
import Doctors from "./Doctors";
import PaymentWay from "./PaymentWay";
import PaymentWayBranch from "./PaymentWayBranch";
import DoctorsSchedule from "./DoctorsSchedule";
import DoctorsScheduleShort from "./DoctorsScheduleShort";
import DoctorsScheduleShortList from "./DoctorsScheduleShortList";
import Images from "./Images";
import Clients from "./Clients";
import Insurance from "./Insurance";
import ClientNotes from "./ClientNotes";
import ClientsDetails from "./ClientsDetails";
import Cabinets from "./Cabinets";
import Visits from "./Visits";
import Files from "./Files";
import FileStorage from "./FileStorage";
import Reasons from "./Reasons";
import RecommendationTypes from "./RecommendationTypes";
import TreatmentPlans from "./TreatmentPlans";
import ClientRelations from "./ClientRelations";
import AnketaAnswers from "./AnketaAnswers";
import Cities from "./Cities";
import AnketaQuestions from "./AnketaQuestions";
import AnketaQuestionnaireStat from "./AnketaQuestionnaireStat";
import Invoices from "./Invoices";
import PriceCategories from "./PriceCategories";
import Report from "./Report";
import RepeatedVisits from "./RepeatedVisits";
import PriceLists from "./PriceLists";
import TreatmentTasks from "./TreatmentTasks";
import AccountHistory from "./AccountHistory";
import Messages from "./Messages";
import TeethDefects from "./TeethDefects";
import Phrase from "./Phrase";
import MedSection from "./MedSection";
import MedInspection from "./MedInspection";
import MedDiary from "./MedDiary";
import JasperReports from "./JasperReports";
import ClientDocumentsHistory from "./ClientDocumentsHistory";
import DocumentTemplate from "./DocumentTemplate";
import Shifts from "./Shifts";
import Employees from "./Employees";
import EmployeesDetails from "./EmployeesDetails";
import BonusMisty from "./BonusMisty";
import RentgenDoze from "./RentgenDoze";
import Egisz from "./Egisz";

const obj = {
    auth: new Auth(),
    clinics: new Clinics(),
    insurance: new Insurance(),
    doctors: new Doctors(),
    paymentWay: new PaymentWay(),
    paymentWayBranch: new PaymentWayBranch(),
    doctorsSchedule: new DoctorsSchedule(),
    doctorsScheduleShort: new DoctorsScheduleShort(),
    doctorsScheduleShortList: new DoctorsScheduleShortList(),
    images: new Images(),
    clients: new Clients(),
    clientNotes: new ClientNotes(),
    clientsDetails: new ClientsDetails(),
    employees: new Employees(),
    employeesDetails: new EmployeesDetails(),
    cabinets: new Cabinets(),
    visits: new Visits(),
    fileStorage: new FileStorage(),
    reasons: new Reasons(),
    recommendationTypes: new RecommendationTypes(),
    treatmentPlans: new TreatmentPlans(),
    clientRelations: new ClientRelations(),
    anketaAnswers: new AnketaAnswers(),
    cities: new Cities(),
    anketaQuestions: new AnketaQuestions(),
    anketaQuestionnaireStat: new AnketaQuestionnaireStat(),
    invoices: new Invoices(),
    priceCategories: new PriceCategories(),
    report: new Report(),
    repeatedVisits: new RepeatedVisits(),
    priceLists: new PriceLists(),
    treatmentTasks: new TreatmentTasks(),
    shifts: new Shifts(),
    files: new Files(),
    accountHistory: new AccountHistory(),
    messages: new Messages(),
    teethDefects: new TeethDefects(),
    phrase: new Phrase(),
    medSection: new MedSection(),
    medInspection: new MedInspection(),
    medDiary: new MedDiary(),
    jasperReports: new JasperReports(),
    clientDocumentsHistory: new ClientDocumentsHistory(),
    documentTemplate: new DocumentTemplate(),
    bonusMisty: new BonusMisty(),
    egisz: new Egisz(),
    rentgenDoze: new RentgenDoze(),
};

export default obj;
